module.exports = __webpack_public_path__ + "static/media/upload.4d491cd9.svg";